import {declarePropertyDependencies} from 'aurelia-framework';

export class Test {

    constructor() {
        setInterval(() => this.ticks++, 100);
    }
    public name: string = "Hello";

    private ticks: number = 0;

    public getName(firstName) {
        return firstName + this.name2;
    }

    public get name2() {
        return this.ticks;
    }
}

declarePropertyDependencies(Test, 'name2', ['ticks']);